
class OnlineStatus {

	constructor() {
		this.lastOnlineStatusTrigger = 0;
		this.triggerStatusInterval = 300;
		this.triggerOnlineStatus = this.triggerOnlineStatus.bind(this);
		this.trackOnlineStatus = this.trackOnlineStatus.bind(this);
		this.triggerOnlineStatus();
		if (document) {
			document.addEventListener("click", this.triggerOnlineStatus);
			window.addEventListener("focus", this.triggerOnlineStatus);
			window.addEventListener("blur", this.triggerOnlineStatus);
			document.addEventListener("keydown", this.triggerOnlineStatus);
		}
	}

	triggerOnlineStatus() {
		let time = parseInt((new Date()).getTime()/1000);
		if ((this.lastOnlineStatusTrigger + this.triggerStatusInterval) < time) {
			this.lastOnlineStatusTrigger = time;
			this.trackOnlineStatus();
		}
	}

	trackOnlineStatus() {
		$.ajax({
			type: 'post',
			url: '/tracking/onlineStatus',
			data: {
			}
		});
	}

}

export default OnlineStatus


// WEBPACK FOOTER //
// ./jsx/classes/OnlineStatus.js